var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M21.3294 5.31333H24.2507V0.225326C23.7467 0.155992 22.0134 -7.62939e-06 19.9947 -7.62939e-06C15.7827 -7.62939e-06 12.8974 2.64933 12.8974 7.51866V12H8.24939V17.688H12.8974V32H18.5961V17.6893H23.0561L23.7641 12.0013H18.5947V8.08266C18.5961 6.43866 19.0387 5.31333 21.3294 5.31333Z","fill":"#068DAA"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"32","height":"32","fill":"white"})))]);
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
